import { type PropsWithChildren } from 'react';

import { Logo } from '@/app/Home/Logo';
import NotificationWrapper from '@/app/Home/NotificationWrapper';
import { InstanceLink } from '@/components/routing';
import HeaderSetter from '@/hooks/header/HeaderSetter';
import { cn } from '@/lib/utils';
import { ROUTES } from '@/router';

import Layout from './Layout';

const { Content } = Layout;

type Props = {
  title?: string;
  className?: string;
};

/**
 * Use this component for pages outside of /app which take up the full screen and do not use header
 * or sidebar.
 */
const FullPage = ({ title, children, className }: PropsWithChildren<Props>) => {
  return (
    <Layout>
      {title && <HeaderSetter hideHeaderTitle>{title}</HeaderSetter>}
      <InstanceLink className="my-1 self-start px-4 sm:px-6 md:px-16" to={ROUTES.signIn.path}>
        <Logo blackLogo />
      </InstanceLink>
      <Content>
        <NotificationWrapper />
        <div className="flex items-center justify-center overflow-x-hidden overflow-y-auto">
          <div
            className={cn(
              'flex w-full max-w-180 flex-col items-center justify-center gap-6 sm:pt-[6vh]',
              className,
            )}
          >
            {children}
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default FullPage;
